import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHerford() {
  return (
    <CityPageTemplate
      city="Herford"
      slug="herford"
      intro="Herford in Ostwestfalen – smarte Finanzberatung für eine Region mit starker Wirtschaft."
      description="Unabhängige & digitale Finanzberatung für Herford: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
